import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import type { CompanyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import { useGetCompaniesMutation } from '../apis';
import type { CompanyQuerySchema } from '../schemas';

export function AsyncCompanyWithStateSelector({
  disabled,
  ...props
}: FormAsyncComboboxProps<CompanyQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: CompanyQuerySchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const state = item?.addresses?.[0]?.state?.name ?? '';
      const itemName = item.account_number + ' - ' + item.name + (state ? ` (${state})` : '');

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/companies/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={(e) => getName(e as CompanyQuerySchema)}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetCompaniesMutation}
      disabled={disabled}
    />
  );
}
